export enum SalesRoute {
  empty = '',
  invoices = 'invoices',
  externalInvoices = 'external-invoices'
}
